import { ApiError } from '../api/errors';

/**
 * How `POST /notes/{id}/ready` can refuse an approval, from `backend/app/api/ready.py`'s error
 * codes. Kept as a pure classifier, mirroring `saveFailure.ts`'s and
 * `history/retryClassification.ts`'s established pattern, so `ReviewScreen` can branch on
 * outcome without re-deriving the status/code pairing inline. Every kind still shows the
 * server's own Spanish `message` verbatim (`docs/implementation/06-mobile-web.md` 6.6: "show
 * server guard failures") - this only decides whether anything *else* must also happen, such as
 * refetching the session.
 */
export type ReadyFailureKind =
  | 'session_expired'
  | 'nothing_to_approve'
  | 'note_incomplete'
  | 'reference_blocked'
  | 'automatic_review_disabled'
  | 'not_approvable'
  | 'other';

const CODE_TO_KIND: Readonly<Record<string, ReadyFailureKind>> = {
  nothing_to_approve: 'nothing_to_approve',
  note_incomplete: 'note_incomplete',
  reference_blocked: 'reference_blocked',
  automatic_review_disabled: 'automatic_review_disabled',
  note_not_approvable: 'not_approvable',
};

export function classifyReadyFailure(error: ApiError): ReadyFailureKind {
  if (error.isSessionInvalid) {
    return 'session_expired';
  }
  return CODE_TO_KIND[error.code] ?? 'other';
}
